export default __webpack_public_path__ + "static/media/mui.584a3e1a.svg";